import validators from 'modules/validations/validators';
import Field from 'shared-components/FormFields/helpers';
import { CONSTANTS } from 'shared-components/SignupForm/lib/constants';

const runChecklistValidations = (validations = [], val) => {
  if (!validations.length) return undefined;
  return validations.map((validation) => {
    return { ...validation, passed: validation.validator(val).passed };
  });
};

const runValidations = (validations = [], val, fields) => {
  const hasValidations = !!validations.length;

  const newValidations = hasValidations ? [] : undefined;
  let valid = hasValidations ? true : undefined;
  let error = undefined;

  for (let validation of validations) {
    const args = [val];
    if (validation.matchKey)
      args.push(fields[Field.idxFromKey(fields, validation.matchKey)].value);
    const result = validation.validator(...args);
    newValidations.push({ ...validation });
    if (!result.passed) {
      valid = false;
      if (!error) error = result.error;
    }
  }

  return { valid, error, validations: newValidations };
};

export const errors = {
  email: CONSTANTS.ERRORS.EMAIL,
  passwordLength: CONSTANTS.ERRORS.PASSWORD_LENGTH,
  passwordNumber: CONSTANTS.ERRORS.PASSWORD_NUMBER,
  passwordCapitalLetter: CONSTANTS.ERRORS.PASSWORD_CAPITAL_LETTER,
  passwordSpecialCharacter: CONSTANTS.ERRORS.PASSWORD_SPECIAL_CHARACTER,
  passwordConfirmation: CONSTANTS.ERRORS.PASSWORD_CONFIRMATION,
  mobilePhoneLength: CONSTANTS.ERRORS.MOBILE_PHONE_LENGTH,
  required: CONSTANTS.ERRORS.REQUIRED,
};

export default {
  email: validators.create("email", errors.email),
  passwordConfirmation: validators.create("matches", errors.passwordConfirmation),
  required: validators.create("required", errors.required),
  minLength: validators.create("minLength", errors.passwordLength, 8),
  specialCharacter: validators.create("specialCharacter", errors.passwordSpecialCharacter),
  capitalLetter: validators.create("capitalLetter", errors.passwordCapitalLetter),
  digit: validators.create("digit", errors.passwordNumber),
  mobilePhoneLength: validators.create("mobilePhoneLength", errors.mobilePhoneLength, 10),

  runChecklistValidations,
  runValidations,
};
